export default __webpack_public_path__ + "static/media/forgetPassword.3f9d3596.svg";